import { useMutation, useQuery } from "@apollo/client";
import {
  LoadingOverlay,
  Modal,
  Drawer,
  Button,
  ScrollArea,
  useMantineTheme,
  Card,
  Group,
  Avatar,
  Badge,
} from "@mantine/core";
import {
  DEL_ASSIGNED,
  DEL_CATEGORY,
  DEL_Product_CATEGORY,
} from "apollo/mutuations";
import { FiEdit, FiEye } from "react-icons/fi";
import EditIcon from "@mui/icons-material/Edit";
import {
  GET_CATEGORIES,
  GET_Product_CATEGORIES,
  GET_SALESES_WAREHOUSE,
} from "apollo/queries";
import CategoryAddModal from "components/Category/categoryAddModal";
import CategoryEditModal from "components/Category/categoryEditModal";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useState, useEffect } from "react";
import { showNotification } from "@mantine/notifications";
import { Edit, ManualGearbox, Trash } from "tabler-icons-react";
import CategoryDetailModal from "components/Category/categoryDetail";
import Controls from "components/controls/Controls";
import { useViewportSize } from "@mantine/hooks";
import AssginWarehouseModal from "./AssignWarehouse";
import ActionButton from "components/controls/ActionButtonNew";

const SalesWarehouseModal = ({ id }) => {
  const { height } = useViewportSize();
  const [size, setSize] = useState("10");
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  //
  const [opened, setOpened] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);

  const theme = useMantineTheme();

  const { data, loading, fetchMore, refetch } = useQuery(
    GET_SALESES_WAREHOUSE,
    {
      variables: {
        id: id,
      },
      onError(error) {
        setOpenedDelete(false);
        showNotification({
          color: "red",
          title: "Error",
          message: error?.graphQLErrors?.[0]?.message || "Failed to get sales ",
        });
      },
    }
  );

  const [delCategory] = useMutation(DEL_ASSIGNED, {
    update(cache, { data: { deleteAssignedWarehouse } }) {
      cache.updateQuery(
        {
          query: GET_SALESES_WAREHOUSE,
          variables: {
            id: id,
          },
        },
        (data) => {
          return {
            getAssignedWarehouses: {
              data: [
                ...data.getAssignedWarehouses.filter(
                  (category) => category.id !== deleteAssignedWarehouse.id
                ),
              ],
            },
          };
        }
      );
    },
  });

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteCategory = () => {
    delCategory({
      variables: { id: deleteID },
      refetchQueries: [
        {
          query: GET_Product_CATEGORIES,
          variables: {
            supplier_id: id,
            first: parseInt(size),
            page: activePage,
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
      ],
      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Assigned warehouses Deleted Successfully",
        });
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message ||
            "Failed to delete assigned warehouses",
        });
      },
    });
  };
  useEffect(() => {
    setHasMounted(true);
  }, []);
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };

  useEffect(() => {
    refetch();
  }, []);
  const handleChange = (currentPage) => {
    fetchMore({
      variables: {
        first: parseInt(size),
        page: currentPage,
      },
    });
    setActivePage(currentPage);
  };
  if (!hasMounted) {
    return null;
  }

  const headerData = [
    {
      label: "Business Name",
      key: "name",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.warehouse.supplier?.business_name}</span>;
      },
    },
    {
      label: "Name",
      key: "name",
      sortable: true,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.warehouse.name}</span>;
      },
    },
    {
      label: "Region",
      key: "region",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.warehouse.region?.name}</span>;
      },
    },
    {
      label: "Status",
      key: "status",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <span style={{ width: "30%" }}>
            {rowData.warehouse.status === "ACTIVE" ? (
              <Badge variant="light" color="green">
                Active
              </Badge>
            ) : (
              <Badge variant="light" color="red">
                Not Active
              </Badge>
            )}
          </span>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <div>
            <ActionButton
              color="error"
              label="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </ActionButton>
          </div>
        );
      },
    },
  ];

  const optionsData = {
    actionLabel: "Assign Warehouse",
    setAddModal: setOpened,
  };
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
      <div style={{ width: "98%", margin: "auto" }}>
        <Drawer
          opened={openedEdit}
          overlayColor={
            theme.colorScheme === "dark"
              ? theme.colors.dark[9]
              : theme.colors.gray[2]
          }
          overlayOpacity={0.55}
          overlayBlur={3}
          title="Editing a Category"
          padding="xl"
          onClose={() => setOpenedEdit(false)}
          position="bottom"
          size="80%"
        >
          <CategoryEditModal
            setOpenedEdit={setOpenedEdit}
            editId={editId}
            // loading={singleCategoryLoading}
          />
        </Drawer>
        <Drawer
          opened={openedDetail}
          overlayColor={
            theme.colorScheme === "dark"
              ? theme.colors.dark[9]
              : theme.colors.gray[2]
          }
          overlayOpacity={0.55}
          overlayBlur={3}
          title="Category Detail"
          padding="xl"
          onClose={() => setOpenedDetail(false)}
          position="bottom"
          size="80%"
        >
          <CategoryDetailModal Id={editId} />
        </Drawer>

        <Modal
          opened={openedDelete}
          onClose={() => setOpenedDelete(false)}
          title="Warning"
          centered
        >
          <p>Are you sure do you want toRemove warehouse?</p>
          <Group position="right">
            <Button onClick={() => deleteCategory()} color="red">
              Delete
            </Button>
          </Group>
        </Modal>
        <Drawer
          opened={opened}
          onClose={() => setOpened(false)}
          overlayColor={
            theme.colorScheme === "dark"
              ? theme.colors.dark[9]
              : theme.colors.gray[2]
          }
          overlayOpacity={0.55}
          overlayBlur={3}
          title="Asisgn Warehouses"
          padding="xl"
          position="bottom"
          size="80%"
        >
          <AssginWarehouseModal
            total={total}
            activePage={activePage}
            setActivePage={setActivePage}
            setOpened={setOpened}
            setTotal={setTotal}
            id={id}
            size={size}
          />
        </Drawer>

        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              searchInput={false}
              handleChange={handleChange}
              header={headerData}
              optionsData={optionsData}
              loading={loading}
              data={data ? data.getAssignedWarehouses : []}
              handlePageSizeChange={handlePageSizeChange}
            />
          </ScrollArea>
        </Card>
      </div>
    </ScrollArea>
  );
};

export default SalesWarehouseModal;
